module.exports = __webpack_public_path__ + "static/media/cq_editor_evidenziato b.4114deb5.svg";